import { i18n } from '@/i18n';

export default function localeDefaultLocation(isGlobal) {
  if (isGlobal) {
    // TODO instead have PHP use HTTP header Accept-Language to guess the country
    // of origin? e.g., window.__VETSTER.geo.country_guess
    return null;
  }

  switch (i18n.locale) {
    case 'en-CA':
    case 'fr-CA':
      return {
        city: 'Toronto',
        province: 'ON',
        country: 'ca',
      };
    case 'en-GB':
      return {
        city: 'London',
        province: 'ENG',
        country: 'gb',
      };
    default:
      return {
        city: 'New York City',
        province: 'NY',
        country: 'us',
      };
  }
}
